<div class='breadcrumb'>
    <div *ngIf="actualSubmenu">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]="actualSubmenu.menu.module.url">
                        {{actualSubmenu.menu.module.servicio}}
                    </a>
                </li>
                <li class="breadcrumb-item">
                    <a [routerLink]="actualSubmenu.menu.url">
                        {{actualSubmenu.menu.nombre}}
                    </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                    {{actualSubmenu.title}}
                </li>
            </ol>
        </nav>
    </div>
</div>